module.exports = __webpack_public_path__ + "img/tree-03-e-trunk.a617bc51.png";